import React, { Component } from 'react';

class SearchBar extends Component {
	constructor(props) {
		super(props);

		this.state = {term: ''};
	}

	render() {
		return(
			<div className="search-bar">
				<span className='sb-title'>QwikTube</span>
				<input 
					placeholder='Search For Anything'
					value={ this.state.term }
					onChange={ event => this.onInputChange(event.target.value)} />
			</div>
		)
	}

	onInputChange(term) {
		this.setState({term});
		this.props.onSearchTermChange(term);
	}
}

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/search_bar.js